import { frontendURL } from '../../../helper/URLHelper';
import TasksPage from './pages/TasksPage.vue';
import { FEATURE_FLAGS } from '../../../featureFlags';

const commonMeta = {
  featureFlag: FEATURE_FLAGS.CRM,
  permissions: ['administrator', 'agent', 'contact_manage'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/tasks'),
    name: 'tasks_dashboard_index',
    component: TasksPage,
    meta: commonMeta,
  },
];
